(function () {
    "use strict";

    document.addEventListener('DOMContentLoaded', function () {
        let cookie_array = window.getCookie('img_banners');
        if (cookie_array === "") {
            cookie_array = [];
        } else {
            try {
                cookie_array = JSON.parse(cookie_array);
            } catch (e) {
                cookie_array = [];
            }
        }

        document.querySelectorAll('.image-banner-parent.removeable').forEach(el => {
            const bannerId = el.getAttribute('id');
            if (cookie_array.indexOf(bannerId) !== -1) {
                el.style.display = 'none';
            }
            if (!el.querySelector('.close-btn')) {
                const btn = document.createElement('button');
                btn.className = 'close-btn';
                btn.innerHTML = '<i class="fi fi-sr-x"></i>';
                el.appendChild(btn);
            }
        });

        document.addEventListener('click', function (e) {
            const closeBtn = e.target.closest('.image-banner-parent.removeable button.close-btn');
            if (closeBtn) {
                const banner = closeBtn.closest('.image-banner-parent.removeable');
                if (banner) {
                    const bannerId = banner.getAttribute("id");
                    if (cookie_array.indexOf(bannerId) === -1) {
                        cookie_array.push(bannerId);
                    }
                    window.setCookie("img_banners", JSON.stringify(cookie_array), 10, false);
                    banner.style.transition = 'all 0.3s ease';
                    banner.style.height = '0px';
                    banner.style.opacity = '0';
                    banner.style.padding = '0px';
                    banner.style.margin = '0px';
                    setTimeout(() => banner.style.display = 'none', 300);
                }
            }
        });

        if (window.getCookie('negarshop_popup') !== "hidden") {
            const popupEl = document.getElementById('negarshop-popup');
            if (popupEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                bootstrap.Modal.getOrCreateInstance(popupEl).show();
            }
        }

        document.addEventListener('click', function (e) {
            const popupLink = e.target.closest('#negarshop-popup .negarshop-popup-link');
            if (popupLink) {
                const popupEl = document.getElementById('negarshop-popup');
                const cook_time = popupEl ? popupEl.getAttribute('data-time') : 86400;
                window.setCookie('negarshop_popup', 'hidden', cook_time, true);
                if (popupEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                    bootstrap.Modal.getOrCreateInstance(popupEl).hide();
                }
            }
        });

        document.addEventListener('hidden.bs.modal', function (e) {
            const popupEl = e.target.closest('#negarshop-popup');
            if (popupEl) {
                const cook_time = popupEl.getAttribute('data-time');
                window.setCookie('negarshop_popup', 'hidden', cook_time, true);
            }
        });

        // Lazy image loader style removal on complete load
        document.querySelectorAll('img.lazy').forEach(img => {
            img.addEventListener('load', function () {
                const figure = img.closest('figure.thumb');
                if (figure) figure.style.backgroundImage = 'none';
            });
            if (img.complete) {
                img.dispatchEvent(new Event('load'));
            }
        });

        const siteLoader = document.querySelector('.site-loader');
        if (siteLoader) {
            setTimeout(() => {
                siteLoader.style.transition = 'opacity 0.5s';
                siteLoader.style.opacity = '0';
                setTimeout(() => siteLoader.style.display = 'none', 500);
            }, 1000);
        }

        if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
            document.querySelectorAll('[data-toggle="tooltip"]').forEach(el => {
                new bootstrap.Tooltip(el);
            });
        }
    });

    document.addEventListener('click', function (e) {
        // Main menu toggle
        const mainMenuBtn = e.target.closest("#main-menu-btn");
        if (mainMenuBtn) {
            const sideMenu = document.getElementById("side-menu");
            if (sideMenu) sideMenu.classList.add('show');
            return;
        }

        // Mask clicks
        const uiMask = e.target.closest(".ui-mask");
        if (uiMask) {
            const sideMenu = document.getElementById("side-menu");
            if (sideMenu) sideMenu.classList.remove('show');
            document.querySelectorAll(".side-nav").forEach(el => el.classList.remove('show'));
            return;
        }

        // Menu submenus toggling
        const toggleBtn = e.target.closest("#side-menu nav li.menu-item-has-children span.toggle");
        if (toggleBtn) {
            toggleBtn.classList.toggle('active');
            const siblingUl = toggleBtn.nextElementSibling;
            if (siblingUl && siblingUl.tagName === 'UL') {
                if (siblingUl.style.display === 'block') {
                    siblingUl.style.display = 'none';
                } else {
                    siblingUl.style.display = 'block';
                }
            }
            return;
        }

        // Responsive header action menu
        const actionMenuBtn = e.target.closest('#header-action-menu-btn');
        if (actionMenuBtn) {
            actionMenuBtn.classList.toggle('active');
            const bottomHeader = document.querySelector('header#header.style-negarshop-light .bottom');
            if (bottomHeader) bottomHeader.classList.toggle('show');
            return;
        }

        // Scroll to top button
        const toTopBtn = e.target.closest('#negarshop-to-top');
        if (toTopBtn) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        // Responsive menu popup
        const responsiveToggleMenu = e.target.closest(".responsive-menu .toggle-menu");
        if (responsiveToggleMenu) {
            const popup = responsiveToggleMenu.nextElementSibling;
            if (popup && popup.classList.contains("menu-popup")) popup.classList.add('show');
            return;
        }

        const responsiveOverlay = e.target.closest(".responsive-menu .overlay");
        if (responsiveOverlay) {
            const popup = responsiveOverlay.previousElementSibling;
            if (popup && popup.classList.contains("menu-popup")) popup.classList.remove('show');
            return;
        }

        // Responsive menu item toggle
        const responsiveMenuToggle = e.target.closest(".responsive-menu nav li.menu-item-has-children span.toggle");
        if (responsiveMenuToggle) {
            responsiveMenuToggle.classList.toggle('active');
            const siblingUl = responsiveMenuToggle.nextElementSibling;
            if (siblingUl && siblingUl.tagName === 'UL') {
                if (siblingUl.style.display === 'block') {
                    siblingUl.style.display = 'none';
                } else {
                    siblingUl.style.display = 'block';
                    const prevLink = responsiveMenuToggle.previousElementSibling;
                    const targetHeight = prevLink ? prevLink.offsetHeight : 40;
                    siblingUl.querySelectorAll('span.toggle').forEach(t => {
                        t.style.height = targetHeight + 'px';
                        t.style.width = targetHeight + 'px';
                    });
                }
            }
            return;
        }

        // Responsive footer bar
        const footerBarLink = e.target.closest('#responsive-footer-bar a');
        if (footerBarLink) {
            const targetId = footerBarLink.getAttribute('href');
            const barContents = document.getElementById('responsive-contents');
            const parentLI = footerBarLink.closest('li');
            const parentUL = footerBarLink.closest('ul');

            if (!parentLI || !parentUL) return;

            if (parentLI.classList.contains('back-item')) {
                parentLI.classList.remove('show-item');
                parentUL.querySelectorAll('.active-item').forEach(el => el.classList.remove('active-item'));
                parentLI.classList.add('active-item');

                if (barContents) barContents.classList.remove('show-menu');
                const bar = document.getElementById('responsive-footer-bar');
                if (bar) bar.classList.remove('page-is-showing');
                document.body.classList.remove('mobile-panel-showing');
                e.preventDefault();
                return;
            }

            if ((parentLI.classList.contains('current-page') && parentLI.classList.contains('not-ajax')) || parentLI.classList.contains('close-page')) {
                window.scrollTo({ top: 0, behavior: 'smooth' });

                parentUL.querySelectorAll('.active-item').forEach(el => el.classList.remove('active-item'));
                parentLI.classList.add('active-item');

                if (barContents) barContents.classList.remove('show-menu');
                const bar = document.getElementById('responsive-footer-bar');
                if (bar) bar.classList.remove('page-is-showing');
                document.body.classList.remove('mobile-panel-showing');

                e.preventDefault();
                return;
            }

            if (!parentLI.classList.contains('not-ajax')) {
                parentUL.querySelectorAll('.active-item').forEach(el => el.classList.remove('active-item'));
                parentLI.classList.add('active-item');

                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                    if (barContents) {
                        Array.from(barContents.children).forEach(child => {
                            if (child !== targetElement) child.style.display = 'none';
                        });
                        barContents.classList.add('show-menu');
                    }
                    const bar = document.getElementById('responsive-footer-bar');
                    if (bar) bar.classList.add('page-is-showing');
                    document.body.classList.add('mobile-panel-showing');

                    targetElement.style.display = 'flex';
                    if (barContents) barContents.scrollTop = 0;
                }

                if (!parentUL.querySelector('.current-page')) {
                    const backItem = parentUL.querySelector('.back-item');
                    if (backItem) backItem.classList.add('show-item');
                }

                e.preventDefault();
                return;
            }

            if (parentLI.classList.contains('not-ajax') && !parentLI.classList.contains('current-page')) {
                parentLI.classList.add('pending-show');
                document.body.classList.add('mobile-loading');
                parentUL.querySelectorAll('.active-item').forEach(el => el.classList.remove('active-item'));
                if (barContents) barContents.classList.remove('show-menu');
                const bar = document.getElementById('responsive-footer-bar');
                if (bar) bar.classList.remove('page-is-showing');
                document.body.classList.remove('mobile-panel-showing');
            }
        }
    });

    // Submenu toggle caret injection
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll("#side-menu nav li.menu-item-has-children, footer#footer .footer-copyright nav.footer-menu li.menu-item-has-children").forEach(el => {
            const link = el.querySelector('a');
            if (link && !el.querySelector('.toggle')) {
                const toggle = document.createElement('span');
                toggle.className = 'toggle';
                toggle.innerHTML = '<i class="fi fi-br-angle-down"></i>';
                link.parentNode.insertBefore(toggle, link.nextSibling);
            }
        });
    });

    window.addEventListener('scroll', function () {
        if (typeof window.wpbtt_start === 'function') {
            window.wpbtt_start();
        }
        const bottomBar = document.querySelector('.fixed-bottom-bar');
        if (bottomBar) {
            if (window.scrollY > 0) {
                bottomBar.style.display = 'block';
            } else {
                bottomBar.style.display = 'none';
            }
        }
    });


    document.addEventListener('hide.bs.modal', function (e) {
        const modal = e.target.closest('.modal');
        if (modal) {
            modal.querySelectorAll('video').forEach(video => {
                video.pause();
            });
        }
    });

})();
